import { MutableRefObject, useRef } from 'react';

import { IbExternalServicesTypes } from '../../services/IbExternalServices/APIService';
import { IbExternalServices } from '../../services/IbExternalServices/APIService/index.api';
import { networkCallWithApisauceWithHeaders } from '../../utils/AuthAPIUtils';

import { useAccountsRefreshAuthTokens } from '../useAccountsRefreshAuthTokens';

interface UseIbExternalServicesInterface {
  ibExternalServicesInstance: IbExternalServicesTypes;
}

const useIbExternalServices = (): UseIbExternalServicesInterface => {
  const { refreshTokenApi, getAccessToken, getRefreshToken } =
    useAccountsRefreshAuthTokens();

  const IbExternalServicesRef: MutableRefObject<IbExternalServicesTypes | null> =
    useRef(null);

  if (IbExternalServicesRef.current === null) {
    IbExternalServicesRef.current = new IbExternalServices(
      networkCallWithApisauceWithHeaders({
        refreshAuthTokensAPI: refreshTokenApi,
        getAccessToken,
        getRefreshToken
      })
    );
  }

  return {
    ibExternalServicesInstance: IbExternalServicesRef.current
  };
};

export { useIbExternalServices };
